module.exports = __webpack_public_path__ + "static/img/boy.cc25330.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/boy.png
// module id = zV0d
// module chunks = 2